import { render, staticRenderFns } from "./RaddarPDPOld.vue?vue&type=template&id=476cec66&scoped=true&"
import script from "./RaddarPDPOld.vue?vue&type=script&lang=js&"
export * from "./RaddarPDPOld.vue?vue&type=script&lang=js&"
import style0 from "./RaddarPDPOld.vue?vue&type=style&index=0&id=476cec66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476cec66",
  null
  
)

export default component.exports